module.exports = __webpack_public_path__ + "static/media/slide.f7760573.wav";